import { ICredit } from '@studyportals/datalayer/dist/src/types';
import { DiscountCriteria } from '@studyportals/iu-global-access-initiative/interfaces/DiscountCriteria';

export class IUDiscountCriteria {
	private readonly attributes: string[] = [];

	private readonly countryId: number;
	private readonly deliveryMethod: string;
	private readonly degreeType: string | undefined;
	private readonly educationLevel: string;
	private readonly credits: number | undefined;
	private readonly duration: number | undefined;
	private readonly period: string | undefined;

	public constructor(countryId: number) {
		this.countryId = countryId;
		this.attributes = this.getAttributes();
		this.degreeType = this.getDegreeType();
		this.deliveryMethod = this.getDeliveryMethod();
		this.educationLevel = window.PortalType;
		this.credits = this.getCreditsAmount();
		this.duration = this.getDuration();
		this.period = this.getPeriod();
	}

	public get(): DiscountCriteria {
		return {
			countryId: this.countryId,
			deliveryMethod: this.deliveryMethod,
			degreeType: this.degreeType,
			educationLevel: this.educationLevel,
			credits: this.credits,
			durationAmount: this.duration,
			durationPeriod: this.period
		};
	}

	private getDuration(): number {
		const discountElement = document.querySelector('[data-discount]');
		if (!discountElement) return 0;
		return Number(discountElement.getAttribute('data-duration') || 0);
	}

	private getPeriod(): string {
		const discountElement = document.querySelector('[data-discount]');
		if (!discountElement) return '';
		return discountElement.getAttribute('data-period') || '';
	}

	private getAttributes(): string[] {
		const degreeTags = document.querySelectorAll('.js-degreeTags .js-tag');

		const studyAttributes = [];

		for (const tag of degreeTags) {
			const attribute = (tag as HTMLElement).innerText.trim();
			studyAttributes.push(attribute);
		}

		return studyAttributes;
	}

	private getDeliveryMethod(): string {
		if (this.attributes.includes('Blended')) {
			return 'blended';
		}
		if (this.attributes.includes('Online')) {
			return 'online';
		}
		return 'oncampus';
	}

	private getDegreeType(): string | undefined {
		return this.attributes.includes('M.B.A.') ? 'mba' : undefined;
	}

	private getCreditsAmount(): number | undefined {
		const ects = window.DataLayerStudyData?.credits.find((credit: ICredit) => credit.type === 'ects') as ICredit;
		return ects != null ? ects.amount : ects;
	}
}
